import { Pipe, PipeTransform, Injectable } from '@angular/core';

@Injectable()
export class DecimalService {
  public transform(value: string | number): string {
    return transformValue(value);
  }
}

@Pipe({
  standalone: false, name: 'decimal' })
export class DecimalPipe implements PipeTransform {
  public transform(value: string | number, currency?: string): string {
    return transformValue(value, currency);
  }
}

export function transformValue(value: string | number, currency = ''): string {
  if (!value || typeof value !== 'string') {
    return '';
  }

  /**
   * Check if value is `infinity` in which case return the value without any formatting
   */
  if (value.toLowerCase().includes('infinity')) {
    return value;
  }

  /**
   * Check if the number is negative, value of 0 means true
   */
  const negative = value.toString().indexOf('-');

  if (negative === 0) {
    /**
     * Slice off the negative sign
     */
    value = value.slice(1);
  }

  const point = value.toString().indexOf('.');

  if (point === -1) {
    return `${negative === 0 ? '-' : ''}${currency}${addThousandsSeparator(value)}`;
  } else {
    const decimal = value.slice(point),
     whole = value.slice(0, point);

    return `${negative === 0 ? '-' : ''}${currency}${addThousandsSeparator(whole)}${decimal}`;
  }
}

export function addThousandsSeparator(value: string): string {
  const split = value.split('').reverse().join('').match(/.{1,3}/g) || [];

  return split.map((part, index) =>
    part.length < 3 || index === split.length - 1 ? part : `${part},`
  ).join('').split('').reverse().join('');
}
